import { TextField } from "@mui/material";
import React from "react";
import { ICheckInQuestionPropsBase } from "../CheckInQuestions";
import { EditorElementView } from "../../utils/editorUtils";
import DisabledCheckInTooltip from "../tooltips/DisabledCheckInTooltip";
import CheckInTextfield from "./CheckInTextfield";

export type ILongTextQuestionAnswer = {
  text?: string;
};

const LongTextQuestion = ({
  view,
  disableAnswer,
  element,
  handleSetNode,
}: ICheckInQuestionPropsBase<ILongTextQuestionAnswer>) => {
  const answer = element.answer as ILongTextQuestionAnswer;

  const handleChange = (newValue: string | null) => {
    handleSetNode({ answer: { text: newValue } }, true);
  };

  const isCoachView = view === EditorElementView.Coach;
  const isCoachReview = view === EditorElementView.Review;
  const disabled = isCoachView || isCoachReview || disableAnswer;

  return (
    <DisabledCheckInTooltip visible={isCoachView}>
      <CheckInTextfield
        placeholder="Jot down your thoughts..."
        value={answer?.text ?? ""}
        onChange={(e) => handleChange(e.target.value)}
        disabled={disabled}
        fullWidth
        multiline
        rows={3}
        inputProps={{ style: { resize: "vertical" } }}
        sx={{
          // Intentionally overriding `pointerEvents` from parent `CheckIn` container to allow text scrolling.
          // Disable textfield with default styles to prevent from being changed.
          ...(isCoachReview && {
            "& .Mui-disabled": {
              pointerEvents: "auto",
              color: "inherit",
              WebkitTextFillColor: "inherit",
            },
          }),
        }}
      />
    </DisabledCheckInTooltip>
  );
};

export default LongTextQuestion;
